import React from 'react';
import { Redirect } from 'react-router';
import { ERRORHANDLING } from '../../config/routes';
var hasError = function (params) {
    var failedCall = params.find(function (result) { return result.error; });
    if (failedCall)
        return true;
    return false;
};
var defaultErrorResponse = function () {
    var url = window.location.href.replace(window.location.origin, '');
    return (React.createElement(Redirect, { to: {
            pathname: ERRORHANDLING.path,
            state: {
                previousPath: url,
            },
        } }));
};
export { hasError, defaultErrorResponse };
